// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"385":"49280625","603":"a95f281e","978":"3aa21505"}[chunkId] + ".chunk.css";
};